import { Controller } from "@hotwired/stimulus"

// Reemplaza el contenido de un <turbo-frame> por un skeleton mientras dura
// el fetch de una recarga (filtros, búsqueda, paginación inline).
//
// El skeleton viaja en un <template> hermano renderizado por el helper
// admin_reload_frame. Turbo dispara `turbo:before-fetch-request` en el frame
// antes de pedir el HTML nuevo; ahí inyectamos el skeleton. Cuando llega la
// respuesta, Turbo reemplaza el frame entero y el skeleton queda descartado.
//
// Uso (siempre vía helper):
//   <%= admin_reload_frame("communities_table", rows: 10, cols: 6) do %>
//     <%= render "admin/communities/communities_table", presenter: @presenter %>
//   <% end %>
export default class extends Controller {
  static targets = ["skeleton"]

  connect() {
    this.frame = this.element.querySelector("turbo-frame")
    if (!this.frame) return
    this._onBeforeFetch = this.#showSkeleton.bind(this)
    this.frame.addEventListener("turbo:before-fetch-request", this._onBeforeFetch)
  }

  disconnect() {
    if (this.frame && this._onBeforeFetch) {
      this.frame.removeEventListener("turbo:before-fetch-request", this._onBeforeFetch)
    }
  }

  #showSkeleton() {
    if (!this.hasSkeletonTarget) return
    this.frame.innerHTML = this.skeletonTarget.innerHTML
  }
}
